import Api from "./api";

export const fetchChatbotConfiguration = async (pmEntityID, shortToken) => {
  try {
    if (!pmEntityID || !shortToken) {
      return { shouldEnableChatbot: false };
    }

    const headers = {
      "Content-Type": "application/json",
      "accesstoken": shortToken,
    };

    const payload = {
      pMEntityID: pmEntityID,
    };

    const response = await Api.getWellnessConfiguration(payload, headers);

    return {
      shouldEnableChatbot: response?.shouldEnableChatbot === true,
      data: response,
    };
  } catch (error) {
    console.error("Error fetching chatbot configuration:", error);
    return { shouldEnableChatbot: false };
  }
};
